export default __webpack_public_path__ + "static/media/TropomiBE.84ac540f.svg";